/**
 * A copy of `GEOLOCATION_ENABLED_REGIONS` in perfalytics-js
 * (src/consent-management/constants/geolocationEnabledRegions.ts): the places
 * managed geotargeting forces opt-in. Keep it in sync so the wizard presets
 * give the same protections. `*` covers the whole country.
 */
export const MANAGED_OPT_IN_REGIONS: Record<string, Record<string, boolean>> = {
  // EU member states (27) - GDPR applies
  AT: { "*": true }, // Austria
  BE: { "*": true }, // Belgium
  BG: { "*": true }, // Bulgaria
  HR: { "*": true }, // Croatia
  CY: { "*": true }, // Cyprus
  CZ: { "*": true }, // Czech Republic
  DK: { "*": true }, // Denmark
  EE: { "*": true }, // Estonia
  FI: { "*": true }, // Finland
  FR: { "*": true }, // France
  DE: { "*": true }, // Germany
  GR: { "*": true }, // Greece
  HU: { "*": true }, // Hungary
  IE: { "*": true }, // Ireland
  IT: { "*": true }, // Italy
  LV: { "*": true }, // Latvia
  LT: { "*": true }, // Lithuania
  LU: { "*": true }, // Luxembourg
  MT: { "*": true }, // Malta
  NL: { "*": true }, // Netherlands
  PL: { "*": true }, // Poland
  PT: { "*": true }, // Portugal
  RO: { "*": true }, // Romania
  SK: { "*": true }, // Slovakia
  SI: { "*": true }, // Slovenia
  ES: { "*": true }, // Spain
  SE: { "*": true }, // Sweden
  // UK - UK GDPR (post-Brexit equivalent)
  GB: { "*": true }, // United Kingdom
  // EEA and European microstates - GDPR or equivalent
  LI: { "*": true }, // Liechtenstein (EEA)
  CH: { "*": true }, // Switzerland (adequate protection)
  AD: { "*": true }, // Andorra
  MC: { "*": true }, // Monaco
  SM: { "*": true }, // San Marino
  VA: { "*": true }, // Vatican City
  JE: { "*": true }, // Jersey
  GG: { "*": true }, // Guernsey
  GI: { "*": true }, // Gibraltar
  ME: { "*": true }, // Montenegro (EU candidate)
  // French overseas territories - GDPR applies
  GF: { "*": true }, // French Guiana
  GP: { "*": true }, // Guadeloupe
  MQ: { "*": true }, // Martinique
  YT: { "*": true }, // Mayotte
  RE: { "*": true }, // Réunion
  MF: { "*": true }, // Saint Martin
  WF: { "*": true }, // Wallis and Futuna
  PF: { "*": true }, // French Polynesia
  NC: { "*": true }, // New Caledonia
  TF: { "*": true }, // French Southern Territories
  BL: { "*": true }, // Saint Barthélemy
  PM: { "*": true }, // Saint Pierre and Miquelon
  // Dutch territories
  SX: { "*": true }, // Sint Maarten
  AW: { "*": true }, // Aruba
  CW: { "*": true }, // Curaçao
  // Danish territories
  GL: { "*": true }, // Greenland
  AX: { "*": true }, // Åland Islands (Finland)
  // British overseas territories
  AI: { "*": true }, // Anguilla
  BM: { "*": true }, // Bermuda
  IO: { "*": true }, // British Indian Ocean Territory
  VG: { "*": true }, // British Virgin Islands
  KY: { "*": true }, // Cayman Islands
  FK: { "*": true }, // Falkland Islands
  MS: { "*": true }, // Montserrat
  PN: { "*": true }, // Pitcairn Islands
  SH: { "*": true }, // Saint Helena
  GS: { "*": true }, // South Georgia and South Sandwich Islands
  TC: { "*": true }, // Turks and Caicos Islands
  // US states - privacy laws vary by state
  US: {
    AL: false,
    AK: false,
    AZ: false,
    AR: false,
    CA: true,
    CO: true,
    CT: true,
    DE: true,
    FL: false,
    GA: false,
    HI: false,
    ID: false,
    IL: false,
    IN: true,
    IA: true,
    KS: false,
    KY: true,
    LA: false,
    ME: false,
    MD: true,
    MA: false,
    MI: false,
    MN: true,
    MS: false,
    MO: false,
    MT: true,
    NE: true,
    NV: false,
    NH: true,
    NJ: true,
    NM: false,
    NY: false,
    NC: false,
    ND: false,
    OH: false,
    OK: false,
    OR: true,
    PA: false,
    RI: true,
    SC: false,
    SD: false,
    TN: true,
    TX: true,
    UT: true,
    VT: false,
    VA: true,
    WA: false,
    WV: false,
    WI: false,
    WY: false,
    DC: false,
  },
};
